import { Link, useLocation } from "react-router-dom";
import { CheckCircle, Phone, CalendarCheck } from "@phosphor-icons/react";

export default function DealershipThanks() {
  const { state } = useLocation();
  const name = state?.first_name || "there";
  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-16" style={{ background: "#f4f7f8" }} data-testid="dealer-thanks">
      <div className="max-w-xl w-full rounded-2xl bg-white border p-8 sm:p-12" style={{ borderColor: "#dce5e9" }}>
        <CheckCircle size={48} weight="fill" style={{ color: "#176fe4" }} />
        <h1 className="mt-5 text-3xl sm:text-4xl font-black tracking-tight" style={{ color: "#102c42" }}>Thanks, {name}. Your demo request is in.</h1>
        <p className="mt-4 text-base" style={{ color: "#607281" }}>We've emailed you a confirmation{state?.ref ? <> (reference <strong className="font-mono">{state.ref}</strong>)</> : null}. An Orbit team member will reach out shortly to schedule a 20-minute walkthrough{state?.pilot ? " and talk through pilot program options" : ""}.</p>
        <div className="mt-8 grid gap-3">
          <Link to="/dealerships/book-demo" className="inline-flex items-center justify-center gap-2 rounded-[7px] px-6 py-4 text-base font-bold text-white" style={{ background: "#176fe4" }} data-testid="thanks-book">
            <CalendarCheck size={20} weight="bold" /> Pick a demo time now
          </Link>
          <a href="tel:+13373595408" className="inline-flex items-center justify-center gap-2 rounded-[7px] px-6 py-4 text-base font-bold border" style={{ color: "#102c42", borderColor: "#dce5e9" }} data-testid="thanks-call">
            <Phone size={20} weight="bold" /> Or call 337-359-5408
          </a>
        </div>
        <p className="mt-8 text-sm"><Link to="/dealerships" className="font-bold underline" style={{ color: "#176fe4" }}>← Back to Orbit for Dealerships</Link></p>
      </div>
    </div>
  );
}
